
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ScrollService {
	scrollPosition$: Subject<number> = new Subject<number>(); // Subject to emit scroll position
	scrollToTop$: Subject<void> = new Subject<void>(); // Subject to trigger scrolling to top
	scrollContainer: HTMLElement | null = null; // Reference to the scroll container element
	selectMenuOpen = false;

	// Method to handle scroll event
	handleScroll(event: Event) {
		const scrollPosition = (event.target as HTMLElement).scrollTop;
		this.scrollPosition$.next(scrollPosition);
	}

	// Method to trigger scrolling to top
	triggerScrollToTop() {
		this.scrollToTop$.next();
	}

	adjustScrollOnMatSelectOpen(opened: boolean): void {
		if (this.scrollContainer) {
			if (opened) {
				this.scrollContainer.style.touchAction = 'none';
				this.scrollContainer.style.pointerEvents = 'none';
				this.scrollContainer.style.overflow = 'scroll';
			} else {
				this.scrollContainer.style.touchAction = '';
				this.scrollContainer.style.pointerEvents = '';
				this.scrollContainer.style.overflow = '';
			}
		}
	}
}